import { render, staticRenderFns } from "./EduQuery.vue?vue&type=template&id=63534f86&scoped=true"
import script from "./EduQuery.vue?vue&type=script&lang=js"
export * from "./EduQuery.vue?vue&type=script&lang=js"
import style0 from "./EduQuery.vue?vue&type=style&index=0&id=63534f86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63534f86",
  null
  
)

export default component.exports